import { useMemo } from "react";
import apiClient from "./apiClient";
import { ReleaseNote, ReleaseNoteInput } from "../state/types";

export const useReleaseNotesApi = () => {
  return useMemo(() => {
    return {
      listReleaseNotesApi: async (): Promise<ReleaseNote[]> => {
        const { data } = await apiClient.get(`/release-notes`);
        return (data?.notes as ReleaseNote[]) || [];
      },

      createReleaseNoteApi: async (note: ReleaseNoteInput): Promise<ReleaseNote> => {
        const { data } = await apiClient.post(`/release-notes`, note);
        return data.note as ReleaseNote;
      },

      updateReleaseNoteApi: async (
        noteId: string,
        note: ReleaseNoteInput,
      ): Promise<void> => {
        await apiClient.put(`/release-notes`, { noteId, ...note });
      },

      deleteReleaseNoteApi: async (noteId: string): Promise<void> => {
        await apiClient.delete(`/release-notes/${encodeURIComponent(noteId)}`);
      },
    };
  }, []);
};
